import { z } from "zod";

export const TextStyleSchema = z.object({
  id: z.string(),
  name: z.string(),
  lineStyle: z.string().default("none"),
  strokeWidth: z.number().default(3),
  stroke: z.string().default("#000000"),
  cornerRadius: z.number().default(0),
  fontSize: z.number(),
  fontWeight: z.string().default("normal"),
  color: z.string(),
  fontFamily: z.string(),
  textAlign: z.string().default("center"),
  fontStyle: z.string(),
  textDecoration: z.string(),
});

export type TextStyle = z.infer<typeof TextStyleSchema>;
